module.exports = __webpack_public_path__ + "img/HC3021-01.300325d3.jpg";